import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";

const routesTree = {
  dashboard: {
    path: "/modules",
    children: {
      imisCities: { path: "/imis-cities" },
      imisDashboard: { path: "/imis-dashboard" },
      imisDataInsertion: { path: "/data-insertion" },
      profile: { path: "/profile" },
      changePassword: { path: "/change-password" },
      projects: {
        path: "/projects",
        children: {
          addProject: { path: "/add-project" },
        },
      },
      userManagement: {
        path: "/manage-users",
        children: {
          permissionManager: { path: "/permission-manager/:id" },
          addUser: { path: "/add-user" },
          addImisUser: { path: "/add-imis-user" },
        },
      },
      kiiManagement: {
        path: "/manage-kii",
        children: {
          kiiDashboard: { path: "/manage-kii/dashboard" },
          createKii: { path: "/create-kii" },
          kiiCityList: {
            path: "/kii-data-submission-city-list",
            children: {
              dataSubmission: { path: "/kii-data-submission" },
            },
          },
        },
      },
      kiiQuestionnaire: {
        path: "/kii-questionnaire",
        children: {
          selectMethod: { path: "/select-kii-questionnaire-method" },
          createQuestionnaire: { path: "/create-kii-questionnaire" },
          viewQuestionnaire: { path: "/view-kii-questionnaire" },
        },
      },
      surveyManagement: {
        path: "/manage-survey",
        children: {
          kiiDashboard: { path: "/manage-survey/dashboard" },
          createSurvey: { path: "/create-survey" },
          surveyCityList: {
            path: "/survey-data-submission-city-list",
            children: {
              dataSubmission: { path: "/survey-data-submission" },
            },
          },
        },
      },
      surveyQuestionnaire: {
        path: "/survey-questionnaire",
        children: {
          createSurveyQuestionnaire: { path: "/create-survey-questionnaire" },
          viewSurveyQuestionnaire: { path: "/view-survey-questionnaire" },
          selectSurveyMethod: { path: "/select-survey-questionnaire-method" },
        },
      },

      cityProfileDataManagement: {
        path: "/manage-cityprofile-data",
        children: {
          BasicDataInsertion: { path: "/insert-basic-data" },
          MapDataInsertion: { path: "/insert-map-data" },
        },
      },
    },
  },
};

const findParentRoute = (currentPath, tree) => {
  const findParent = (node, path, parent = "/modules") => {
    if (node.path === path) return parent;

    if (node.children) {
      for (const childKey in node.children) {
        const childNode = node.children[childKey];
        const childPath =
          typeof childNode === "string" ? childNode : childNode.path;
        const result = findParent(childNode, path, node.path);
        if (result) return result;
      }
    }

    return null;
  };

  return findParent(tree.dashboard, currentPath);
};

const Back = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2.5}
    stroke="currentColor"
    className="size-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.75 19.5 8.25 12l7.5-7.5"
    />
  </svg>
);

const NavigateButton = ({ text = "Back", icon = null, type = null }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const parentRoute = findParentRoute(location.pathname, routesTree);
  const { t } = useTranslation();

  const handleNav = (event) => {
  

    event.preventDefault();
    event.stopPropagation();
    if (parentRoute) {
      navigate(parentRoute);
    } else navigate("/");
  };

  if (location.pathname === "/modules") {
    return (
      <div
        style={{
          mb: "10px",
          height: "55px",
          ml: "4px",
          borderRadius: "15px",
          borderColor: "#7DDBFF99",
          paddingRight: 3,
          paddingLeft: 1.5,
          paddingY: 1,
          transition: "0.3s",
          "&:hover": {
            backgroundColor: "#7DDBFF55",
            boxShadow: "none",
          },
        }}
      ></div>
    );
  }

  return (
    <Button
      component={Link}
      onClick={handleNav}
      startIcon={icon || <Back />}
      variant="outlined"
      sx={{
        mb: "10px",
        ml: "4px",
        borderRadius: "15px",
        borderColor: "#7DDBFF99",
        paddingRight: 3,
        paddingLeft: 1.5,
        paddingY: 1,
        transition: "0.3s",
        "&:hover": {
          backgroundColor: "#7DDBFF55",
          boxShadow: "none",
        },
      }}
    >
   
      
      {text == "Back" ? t("other.back") : text}
    </Button>
  );
};

export default NavigateButton;
